module.exports = __webpack_public_path__ + "img/bohemia-lx.89620751.jpg";